/* eslint-disable */

import React, { useState } from 'react';
import { IoMenu, IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import meya_logo from '../../assets/images/logo_meya.png';
import './NewNavBar.css';

function NewNavBar(props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const goJobAuth = (mode) => {
    navigate(`/jobs?auth=${mode}`);
  };

  return (
    <>
      <nav className='meya-navbar'>
        <div className='nav-container'>
          <div className='nav-logo' onClick={() => navigate('/')}>
            <div className='logo-img-wrap'>
              <img src={meya_logo} alt='Meya Logo' />
            </div>
            <div className='logo-text'>
              <span className='logo-main'>MEYA MARKET</span>
              <span className='logo-sub'>Marketplace for Pharmacy</span>
            </div>
          </div>

          <div className='nav-actions-desktop'>
            <div className='nav-dropdown nav-auth-pill' role='group' aria-label='บัญชีร้านค้า'>
              <button
                type='button'
                className='nav-auth-pill-action'
                onClick={props.callback_popup_signin}
              >
                เข้าสู่ระบบ
              </button>
              <span className='nav-auth-pill-sep'>/</span>
              <button
                type='button'
                className='nav-auth-pill-action'
                onClick={props.callback_popup_register}
              >
                สมัครสมาชิกร้านค้า
              </button>
            </div>

            <div
              className='btn-register-grad btn-job-search nav-auth-pill nav-auth-pill-solid'
              role='group'
              aria-label='บัญชีหางาน'
            >
              <button
                type='button'
                className='nav-auth-pill-action'
                onClick={() => goJobAuth('login')}
              >
                เข้าสู่ระบบ
              </button>
              <span className='nav-auth-pill-sep'>/</span>
              <button
                type='button'
                className='nav-auth-pill-action'
                onClick={() => goJobAuth('register')}
              >
                สมัครสมาชิกหางาน
              </button>
            </div>
          </div>

          <div className='nav-mobile-toggle' onClick={toggleMenu}>
            {isMenuOpen ? <IoClose size={30} /> : <IoMenu size={30} />}
          </div>
        </div>
      </nav>

      <div className={`mobile-drawer ${isMenuOpen ? 'open' : ''}`}>
        <div className='drawer-header'>
          <div className='logo-img-wrap'>
            <img src={meya_logo} alt='Meya Logo' className='drawer-logo' />
          </div>
          <IoClose size={30} className='drawer-close' onClick={toggleMenu} />
        </div>

        <div className='drawer-content'>
          <div className='nav-dropdown mobile-login-btn nav-auth-pill' role='group'>
            <button
              type='button'
              className='nav-auth-pill-action'
              onClick={() => {
                props.callback_popup_signin();
                toggleMenu();
              }}
            >
              เข้าสู่ระบบ
            </button>
            <span className='nav-auth-pill-sep'>/</span>
            <button
              type='button'
              className='nav-auth-pill-action'
              onClick={() => {
                props.callback_popup_register();
                toggleMenu();
              }}
            >
              สมัครสมาชิกร้านค้า
            </button>
          </div>

          <div
            className='btn-register-grad mobile-cta btn-job-search nav-auth-pill nav-auth-pill-solid'
            role='group'
          >
            <button
              type='button'
              className='nav-auth-pill-action'
              onClick={() => {
                goJobAuth('login');
                toggleMenu();
              }}
            >
              เข้าสู่ระบบ
            </button>
            <span className='nav-auth-pill-sep'>/</span>
            <button
              type='button'
              className='nav-auth-pill-action'
              onClick={() => {
                goJobAuth('register');
                toggleMenu();
              }}
            >
              สมัครสมาชิกหางาน
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && <div className='drawer-overlay' onClick={toggleMenu}></div>}
    </>
  );
}

export default NewNavBar;
